import { memo } from "react";

import { useEditor } from "../EditorContext"
import ConfirmationModal from "../../../common/ConfirmationModal";


const Control = memo(function Control ({control, formStructure}) {

  const {editingElement, setEditingElement, removeElement} = useEditor()
  const isEditing = editingElement === control.id

  let displayFieldType = 
    control.schemaProps.type === 'string' && control.schemaProps.enum ? 'выбор варианта' : 
    control.schemaProps.type === 'string' ? 'строка' : 
    control.schemaProps.type === 'integer' ? 'целое' : 
    control.schemaProps.type === 'number' ? 'дробное' : 
    'неизвестный тип'


  let modalId = 'confirmControlDeleteModal_' + control.id

  return (
    <div>

      <ConfirmationModal
        modalId={modalId}
        headerText="Поле"
        messageText={[
          "Вы уверены, что хотите удалить поле?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => removeElement(formStructure, control.id)}
        danger
      />

      <div className="card-header p-0">
        <div className="row px-3">
          <div className="col-8 d-flex align-items-center">
            <small className="fw-semibold ">{displayFieldType}</small>
          </div>
          <div className="col-4 d-flex align-items-center">
            <button className="btn editor-button mx-1 mt-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-menu-button-wide" viewBox="0 0 16 16">
                <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z"/>
                <path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0M0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
              </svg>
            </button>
            <ul className="dropdown-menu">
              <button className="dropdown-item lk-menu-dropdown" disabled>сдвинуть влево</button>
              <button className="dropdown-item lk-menu-dropdown" disabled>сдвинуть вправо</button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item lk-menu-dropdown" data-bs-toggle="modal" data-bs-target={'#' + modalId}>удалить поле</button> {/* здесь также был добавлен уникальный Id в прошлом коммите */}
            </ul>            
            {isEditing ?
              <>
                <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(undefined)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check-square" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                    <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                  </svg>
                </button>
              </>
            :
              <>
                <button className="btn editor-button mx-0 mt-2" onClick={() => setEditingElement(control.id)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                  </svg>
                </button>
              </>
            }
          </div>
        </div> 
      </div>
      <div className="card-body">
        <p className="editor-elem-text pb-2 text-truncate"><span className="fw-bold">имя: </span> {control.scope.slice(2).split('/').pop()}</p>

        <p className="editor-elem-text text-truncate"><span className="fw-bold">аналит: </span> {control.schemaProps.prop_analyte}</p>
        {control.schemaProps.prop_kv ?
          <p className="editor-elem-text text-truncate"><span className="fw-bold">kv: </span> {control.schemaProps.prop_kv}</p>
        :
          <></>
        }
        {control.schemaProps.prop_kv && control.schemaProps.prop_kv === 'measure' ?
          <p className="editor-elem-text text-truncate"><span className="fw-bold">measure: </span> {control.schemaProps.prop_measure}</p>
        :
          <></>
        }

        {/* 
        <table>
          <tr>
            <td className="editor-elem-text pe-3"><span className="fw-bold">аналит: </span></td>
            <td className="editor-elem-text">{control.schemaProps.prop_analyte}</td>
          </tr>
          <tr>
            <td className="editor-elem-text pe-3"><span className="fw-bold">kv: </span></td>
            <td className="editor-elem-text">{control.schemaProps.prop_kv}</td>
          </tr>


          {control.schemaProps.prop_kv && control.schemaProps.prop_kv === 'measure' ?
            <tr>
              <td className="editor-elem-text pe-3"><span className="fw-bold">measure: </span> </td>
              <td className="editor-elem-text">{control.schemaProps.prop_measure}  </td>
            </tr>
          :
            <></>
          }
        </table>
        */}
      </div>
    </div>
  )
})

export default Control
